import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '../../components/Button';
import Input from '../../components/Input';

import { useSocket } from '../../context/SocketContext';

export default function Home() {
  const socket = useSocket();
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState<string | undefined>(undefined);

  const joinRoom = (roomId: string) => {
    navigate(`/room/${roomId}`);
  };

  const createRoom = () => {
    socket.emit('createRoom', (newRoomId: string) => {
      joinRoom(newRoomId);
    });
  };

  return (
    <div className="h-screen w-full flex items-center justify-center flex-col">
      <div className="flex flex-col gap-3">
        <Input
          id="room-id"
          name="Code"
          value={roomId || ''}
          setValue={setRoomId}
        />

        <Button onClick={() => joinRoom(roomId || '')}>Join Room</Button>
      </div>

      <p className="text-gray-500 my-4">or</p>

      <Button onClick={() => createRoom()}>Create Room</Button>
    </div>
  );
}
